import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactTable from "react-table";
import 'react-table/react-table.css';




const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class SalutationList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            salutations: [],
            filter: {},
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        
    }
    

    async componentDidMount() {
        console.log("In CityscopeList componentDidMount");
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        
        try {
            const salutations = await this.getSalutations();
            this.setState({ salutations });
        } catch (e) {
            alert(e);
        }

        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ salutations: [] });        
    }


    
    async getSalutations() {
        console.log("Inside getSalutations() ");
        
        return API.get("colin", "/salutations/all");
      
    }

    

    addRecord = async event => {
        let salutations = [...this.state.salutations];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        salutations.push({
            appendix:0,
            include_globe: false,
            allow_editing: false,
            led_occs: false,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.setState({salutations});
    }

    

    async saveRecord(record) {
        
        record.last_edited_by= this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                
                return API.post("colin", `/salutations/new`, {
                    body: record
                });
                
                
            }
        }
    
        return API.put("colin", `/salutations/${record["id"]}`, {
            body: record
        });
        
        

       
    }

    validateRecord(record) {

       
        //Check street name not blank
        if (record.salutation === "") {
            return [false,"Salutation cannot be blank. The record has not been saved"];
        }
       
        return [true,];
    }


    async handleDataSave(data) {
        try {
            return await this.saveRecord(data);


        } catch (e) {
            alert("Error saving");
        }
    }

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let salutations = [...this.state.salutations];
        salutations[cellInfo.index][cellInfo.column.id] = event.target.value;
        salutations[cellInfo.index].modified = true;
        this.setState({salutations});
    };
    handleNumberChange = (cellInfo, event) => {
        let salutations = [...this.state.salutations];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        salutations[cellInfo.index][cellInfo.column.id] = Number(val);
        salutations[cellInfo.index].modified = true;
        this.setState({salutations});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let salutations = [...this.state.salutations];
        salutations[cellInfo.index][cellInfo.column.id] = event.target.checked;
        salutations[cellInfo.index].modified = true;
        this.setState({salutations});
    };

    handleDateChange = (cellInfo, event) => {
        let salutations = [...this.state.salutations];
        salutations[cellInfo.index][cellInfo.column.id] = new Date(event);
        salutations[cellInfo.index].modified = true;
        this.setState({salutations});

    }

    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false });
        let salutations = [...this.state.salutations];
        for (var i=0; i<salutations.length; i++){
            const validation = this.validateRecord(salutations[i]);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (salutations[i].hasOwnProperty("modified")) {
                    if (salutations[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (salutations[i].hasOwnProperty("new_record")) {
                                if (salutations[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(salutations[i]);
                            if (result.result) {
                                salutations[i].modified = false;
                                if (salutations[i].hasOwnProperty("new_record")) {
                                    if (salutations[i].new_record === true) {

                                        salutations[i].id = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    salutations[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   
        if (salutations[0].hasOwnProperty("sort_order")) {
            salutations.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        
        this.setState({salutations});

    }


    renderEditable = cellInfo => {
        const cellValue = this.state.salutations[cellInfo.index][cellInfo.column.id];


        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }
        }
    }

    
    
    
    
      
    
    renderTable(data) {
        const columns = [

            {
                id: 'salutation',
                Header: 'Salutation',
                maxWidth: 250,
                accessor: 'salutation' ,
                Cell: this.renderEditable
                

        }
        
         
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={30}
                    sortable={false}
                />
            )
        }
    }

    
    renderComponent() {
        return (
            <div className="salutations">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                <Row >
                    <Col className="text-right" >                            
                            <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>
                            
                                
                                
                        </Col>
                    </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.state.salutations) : this.renderTable(this.state.salutations)  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="CityscopeList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
